export default __webpack_public_path__ + "IshLogoWhite.svg";